import { get, isString, set } from 'lodash';

import { ERROR_CONTEXT_PATH, REDACTED_TEXT, sanitizationContexts } from '../constants';
import type { RollbarPayload, SanitizationContextConfig } from '../types';

export const appendErrorContext = (payload: RollbarPayload) => {
  const errorContext = get(payload, ERROR_CONTEXT_PATH);

  if (errorContext) {
    set(payload, 'context', errorContext);
  }
};

export const getRollbarUrl = () => {
  const url = window.location.origin;
  return `${url.replace('app', 'exceptions')}/`;
};

/**
 * Applies sanitization based on the specified context.
 *
 * @param payload - The Rollbar payload object to sanitize.
 * @param context - The sanitization context name.
 */
export const sanitizePayloadByContext = (
  payload: RollbarPayload,
  context: keyof SanitizationContextConfig,
) => {
  const config = sanitizationContexts[context];

  if (!config) {
    throw new Error(`Unknown sanitization context: ${context}`);
  }

  const { paths, sanitizers } = config;

  paths.forEach((path) => {
    const text = get(payload, path);

    if (isString(text)) {
      set(
        payload,
        path,
        sanitizers.reduce((acc, sanitizer) => sanitizer(acc), text),
      );
    }
  });
};

export const slateScrubber = (key: string, value: string) => {
  if (key === 'text') return REDACTED_TEXT;
  if (key === 'url') return REDACTED_TEXT;
  return value;
};
